<template>
  <v-card height="85vh">
    <v-card-title>Introduce o edita los datos de tu lavandería</v-card-title>
    <v-card-subtitle>Estos datos se usarán en sus tickets</v-card-subtitle>
    <v-card-text>
      <v-form>
        <v-row>
          <v-col cols="4">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="nombreLavanderia"
                  label="Nombre Lavandería"
                  prepend-icon="mdi-storefront-outline"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="telefono"
                  prepend-icon="mdi-phone"
                  label="Teléfono"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" offset="1">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="direccion"
                  label="Calle, Número y Colonia"
                  prepend-icon="mdi-map"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field 
                  v-model="ciudad" 
                  label="Ciudad"
                  prepend-icon="mdi-city"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="estado" label="Estado"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="codigoPostal" label="C.P"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-menu
              ref="menu"
              v-model="menuHoraApertura"
              :close-on-content-click="false"
              :nudge-right="130"
              transition="scale-transition"
              offset-y
              offset-x
              :nudge-width="200"
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="horaApertura"
                  label="Selecciona Horario de Apertura"
                  prepend-icon="mdi-clock-time-four-outline"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="menuHoraApertura"
                v-model="horaApertura"
                full-width
                @click:minute="$refs.menu.save(horaApertura)"
              ></v-time-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <v-menu
              ref="menu"
              v-model="menuHoraCierre"
              :close-on-content-click="false"
              :nudge-right="130"
              transition="scale-transition"
              offset-x
              :nudge-width="200"
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="horaCierre"
                  label="Selecciona Horario de Cierre"
                  prepend-icon="mdi-clock-time-four-outline"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="menuHoraCierre"
                v-model="horaCierre"
                full-width
                @click:minute="$refs.menu.save(horaCierre)"
              ></v-time-picker>
            </v-menu>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions class="fix-to-bottom">
      <v-btn @click="guardarDatosLavanderia" 
        color="purple" outlined>Guardar</v-btn>
      <v-btn 
        @click="cancelarEdicionDatosLavanderia" 
        color="red" outlined
        >Cancelar</v-btn
      >
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
// const { getLaundryInfo, updateLaundryInfo } = api.services.settingsService;
export default {
  name: "DatosNegocio",
  data() {
    return {
      nombreLavanderia: "",
      telefono: "",
      direccion: "",
      ciudad: "",
      estado: "",
      pais: "México",
      codigoPostal: "",
      menuHoraApertura: false,
      menuHoraCierre: false,
      horaApertura: null,
      horaCierre: null,
    };
  },
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    ...mapActions(["showLoadingIndicator"]),
    getLaundryInfo(){},
    updateLaundryInfo(){},
    guardarDatosLavanderia() {
      this.showLoadingIndicator(true);
      const laundryInfo = {
        nombreLavanderia: this.nombreLavanderia,
        telefono: this.telefono,
        direccion: this.direccion,
        ciudad: this.ciudad,
        estado: this.estado,
        pais: this.pais,
        codigoPostal: this.codigoPostal,
        horaApertura: this.horaApertura,
        horaCierre: this.horaCierre,
      };
      const successfullChanges = this.updateLaundryInfo({
        idUsuario: this.user.id,
        value: laundryInfo,
      });
      if (successfullChanges) {
        this.loadLaundryInfo();
        setTimeout(() => {
          this.showLoadingIndicator(false);
        }, 1000);
      }
    },
    cancelarEdicionDatosLavanderia() {
      this.loadingMsg = "Restaurando datos";
      this.saving = true;
      this.loadLaundryInfo();
      setTimeout(() => {
        this.showLoadingIndicator(false);
      }, 1000);
    },
    loadLaundryInfo() {
      const laundryInfo = this.getLaundryInfo();
      const {
        nombreLavanderia,
        telefono,
        direccion,
        ciudad,
        estado,
        codigoPostal,
        horaApertura,
        horaCierre
      } = JSON.parse(laundryInfo.value);
      this.nombreLavanderia = nombreLavanderia;
      this.telefono = telefono;
      this.direccion = direccion;
      this.ciudad = ciudad;
      this.estado = estado;
      this.codigoPostal = codigoPostal;
      this.horaApertura = horaApertura;
      this.horaCierre = horaCierre;
    },
  },
  beforeMount() {
    this.loadLaundryInfo();
  },
};
</script>